import { createSelector } from 'reselect';
import { size } from 'lodash';
import { UiState } from 'constants/ui';
import { DeliveryType, stateName } from '../constants';

const checkoutState = state => state[stateName];

const localState = state => checkoutState(state).shipping;

const getCheckoutState = createSelector(checkoutState, _ref => {
  let {
    checkout
  } = _ref;
  return checkout;
});
const getCheckoutUiState = createSelector(getCheckoutState, _ref2 => {
  let {
    ui
  } = _ref2;
  return ui;
});
const getCheckoutData = createSelector(getCheckoutState, _ref3 => {
  let {
    checkoutData
  } = _ref3;
  return checkoutData;
});
const getCheckoutShippingService = createSelector(getCheckoutData, checkoutData => checkoutData === null || checkoutData === void 0 ? void 0 : checkoutData.services.shipping);
export const getShipment = createSelector(getCheckoutData, checkoutData => (checkoutData === null || checkoutData === void 0 ? void 0 : checkoutData.shipment) || null);
export const getCountryBounds = createSelector(localState, _ref4 => {
  let {
    countryBounds
  } = _ref4;
  return countryBounds;
});
export const getNearbyPoints = createSelector(localState, _ref5 => {
  let {
    nearbyPoints
  } = _ref5;
  return nearbyPoints;
});
export const getUiState = createSelector(localState, _ref6 => {
  let {
    ui
  } = _ref6;
  return ui;
});
export const getDeliveryOptionsUiState = createSelector(getCheckoutUiState, _ref7 => {
  let {
    checkoutData
  } = _ref7;
  return checkoutData;
});
export const getPickupModalUiState = createSelector(getUiState, _ref8 => {
  let {
    pickupModal
  } = _ref8;
  return pickupModal;
});
export const getPickupModalUiStateByElement = (state, element) => localState(state).ui.pickupModal[element];
export const getIsPickupModalElementLoaded = (state, element) => [UiState.Success, UiState.Failure].includes(localState(state).ui.pickupModal[element]);
export const getPickupPoint = createSelector(getShipment, shipment => shipment === null || shipment === void 0 ? void 0 : shipment.pickupPoint);
export const getIsShipmentActionable = createSelector(getShipment, shipment => {
  var _shipment$carrier, _shipment$carrier2;

  return !(shipment !== null && shipment !== void 0 && (_shipment$carrier = shipment.carrier) !== null && _shipment$carrier !== void 0 && _shipment$carrier.custom) && !(shipment !== null && shipment !== void 0 && (_shipment$carrier2 = shipment.carrier) !== null && _shipment$carrier2 !== void 0 && _shipment$carrier2.noShipping);
});
export const getSelectedDeliveryType = createSelector(getCheckoutShippingService, checkoutShippingService => (checkoutShippingService === null || checkoutShippingService === void 0 ? void 0 : checkoutShippingService.selectedDeliveryType) || null);
export const getDeliveryPickupPointDetails = createSelector(getShipment, shipment => {
  var _shipment$packageType, _shipment$carrier3;

  return {
    title: (shipment === null || shipment === void 0 ? void 0 : (_shipment$packageType = shipment.packageType) === null || _shipment$packageType === void 0 ? void 0 : _shipment$packageType.title) || (shipment === null || shipment === void 0 ? void 0 : (_shipment$carrier3 = shipment.carrier) === null || _shipment$carrier3 === void 0 ? void 0 : _shipment$carrier3.buyerTitle),
    packageType: shipment === null || shipment === void 0 ? void 0 : shipment.packageType,
    carrier: shipment === null || shipment === void 0 ? void 0 : shipment.carrier
  };
});
export const getPackageType = createSelector(getShipment, shipment => shipment === null || shipment === void 0 ? void 0 : shipment.packageType);
export const getBuyerPhoneRequirement = createSelector(getPackageType, packageType => packageType === null || packageType === void 0 ? void 0 : packageType.buyerPhoneRequirement);
export const getSuggestedShippingPointCode = createSelector(localState, _ref9 => {
  let {
    suggestedShippingPointCode
  } = _ref9;
  return suggestedShippingPointCode;
});
export const getIsIntergratedShipping = createSelector(getShipment, shipment => {
  if (!(shipment !== null && shipment !== void 0 && shipment.carrier)) return false;

  switch (shipment.carrier.deliveryType) {
    case DeliveryType.Home:
    case DeliveryType.PickupPoint:
      return true;

    default:
      return false;
  }
});
export const getSelectedShippingPoint = createSelector(localState, _ref10 => {
  let {
    selectedShippingPoint
  } = _ref10;
  return selectedShippingPoint;
});
export const getPickupPointsUiState = createSelector(getUiState, _ref11 => {
  let {
    pickupPoints
  } = _ref11;
  return pickupPoints;
});
export const getShippingOptions = createSelector(localState, _ref12 => {
  let {
    shippingOptions
  } = _ref12;
  return shippingOptions;
});
export const getDeliveryTypesUiState = createSelector(getCheckoutUiState, _ref13 => {
  let {
    checkoutData
  } = _ref13;
  return checkoutData;
});
export const getDeliveryTypes = createSelector(getCheckoutData, checkoutData => {
  var _checkoutData$service, _checkoutData$service2;

  return (_checkoutData$service = checkoutData === null || checkoutData === void 0 ? void 0 : (_checkoutData$service2 = checkoutData.services.shipping) === null || _checkoutData$service2 === void 0 ? void 0 : _checkoutData$service2.deliveryTypes) !== null && _checkoutData$service !== void 0 ? _checkoutData$service : null;
});
export const getDeliveryTypesSize = createSelector(getDeliveryTypes, deliveryTypes => size(deliveryTypes));
export const getRateUuid = createSelector(getShipment, shipment => shipment === null || shipment === void 0 ? void 0 : shipment.rateUuid);
export const getIsItemOfflineVerificationEnabled = createSelector(getCheckoutData, checkoutData => checkoutData === null || checkoutData === void 0 ? void 0 : checkoutData.shipment.packageType.itemOfflineVerificationEnabled);